import {
  HttpErrorResponse,
  HttpInterceptorFn,
  HttpResponse,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { tap } from 'rxjs';

import { APP_ENV } from '../data-access/app-config';

/**
 * Logs every outgoing HTTP request and its response/error to the console.
 * Useful for debugging API calls on native (view via Safari Web Inspector
 * or the native device console). Prefix `[HTTP]` makes entries easy to filter.
 *
 * Disabled in production builds (gated on `APP_ENV.production`).
 */
export const loggingInterceptor: HttpInterceptorFn = (req, next) => {
  const appEnv = inject(APP_ENV);
  if (appEnv.production) {
    return next(req);
  }

  const startedAt = Date.now();
  // eslint-disable-next-line no-console
  console.log(`[HTTP] --> ${req.method} ${req.urlWithParams}`, {
    headers: headersToObject(req),
    body: req.body,
  });

  return next(req).pipe(
    tap({
      next: (event) => {
        if (event instanceof HttpResponse) {
          const ms = Date.now() - startedAt;
          // eslint-disable-next-line no-console
          console.log(
            `[HTTP] <-- ${event.status} ${req.method} ${req.urlWithParams} (${ms}ms)`,
            event.body,
          );
        }
      },
      error: (error: unknown) => {
        const ms = Date.now() - startedAt;
        if (error instanceof HttpErrorResponse) {
          // eslint-disable-next-line no-console
          console.error(
            `[HTTP] xxx ${error.status} ${req.method} ${req.urlWithParams} (${ms}ms)`,
            error.error,
          );
        } else {
          // eslint-disable-next-line no-console
          console.error(
            `[HTTP] xxx ERROR ${req.method} ${req.urlWithParams} (${ms}ms)`,
            error,
          );
        }
      },
    }),
  );
};

function headersToObject(req: {
  headers: { keys(): string[]; get(name: string): string | null };
}): Record<string, string | null> {
  const result: Record<string, string | null> = {};
  for (const key of req.headers.keys()) {
    result[key] = req.headers.get(key);
  }
  return result;
}
